import { useState, createRef, useEffect } from "react";
import * as SignalR from "@microsoft/signalr";
import { useSelector } from "react-redux";
import { getSubtaskConsoleMessages } from "../../services/calculationsService";
import { AppState } from "../../store/configureStore";
import streamConsole from "../../services/consoleHubService";
import "./ConsoleStream.css";

interface IProps {
    taskId: string;
}

let msgs: string[] = [];

export const ConsoleStream = ({ taskId }: IProps) => {
    const [consoleData, setConsoleData] = useState<string[]>([]);
    const [bottomScrollLock, setBottomScrollLock] = useState<boolean>(true);
    const [connection, setConnection] = useState<SignalR.HubConnection>();
    const user = useSelector((state: AppState) => state.user);
    const textAreaRef = createRef<HTMLTextAreaElement>();

    const onReceiveMsg = (msg: string) => {
        msgs = [...msgs, msg];
        setConsoleData(msgs);
    };

    const handleScroll = (e: any) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) setBottomScrollLock(true);
        else setBottomScrollLock(false);
    };

    useEffect(() => {
        if (bottomScrollLock && textAreaRef.current)
            textAreaRef.current.scrollTop = textAreaRef.current.scrollHeight;
    }, [bottomScrollLock, consoleData, textAreaRef]);

    useEffect(() => {
        if (taskId.length > 0 && !connection) {
            getSubtaskConsoleMessages(taskId).then(res => {
                msgs = [];
                res.forEach(entry => msgs.push(entry.message));
                setConsoleData(msgs);
                streamConsole(user.token, taskId, onReceiveMsg)
                    .then((con: SignalR.HubConnection) => setConnection(con))
                    .then(() => setBottomScrollLock(true));
            });
        }
        return () => {
            if (connection) connection.stop();
        };
    }, [taskId, connection, user.token]);

    return (
        <textarea
            id="console-consoleStream"
            readOnly
            ref={textAreaRef}
            className="console"
            value={consoleData.join("\n")}
            onScroll={handleScroll}
        />
    );
};
